import styled from 'styled-components';
import globalStyles from '../global-styles';

// padding-right is because of the Icon

export default styled.select`
  ${globalStyles}
  width: 100%;
  padding-right: 2.25rem;
  appearance: none;
  &::-ms-expand {
    display: none;
  }
  &:disabled {
    opacity: 0.9;
    cursor: not-allowed;
  }
`;
